<template>
  <div :class="['blue-button', widthClass]">
    <b-overlay :show="loading" opacity="0.8">
      <b-button
        :disabled="disabled"
        @click.stop="$emit('clicked')"
        class="rounded-pill"
      >
        <img v-show="src !== null" :src="src" alt="" />
        {{ label }}
      </b-button>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "PrimaryButton",

  props: {
    label: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    widthClass: {
      type: String,
      default: "button-fit-content",
    },
  },
};
</script>

<style>
.blue-button .spinner-border {
  height: 1.563rem;
  width: 1.563rem;
  margin-top: 0.188rem;
  border: 0.25em solid var(--color-white);
  border-right-color: transparent;
}

.blue-button .btn-secondary {
  background-color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
  color: var(--color-white);
  padding: 0.25rem 1.125rem;
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-600);
  display: flex;
  align-items: normal;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;
}
.blue-button .btn-secondary.disabled,
.btn-secondary:disabled {
  opacity: 0.65;
}

.blue-button .btn-secondary:hover {
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.blue-button .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--color-white);
  box-shadow: none;
}

.blue-button .btn-secondary:disabled {
  box-shadow: none;
}

.blue-button .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--color-white);
  box-shadow: none;
}

.blue-button .btn-secondary:not(:disabled):not(.disabled):active,
.blue-button .btn-secondary:not(:disabled):not(.disabled).active,
.blue-button .show > .btn-secondary.dropdown-toggle {
  color: var(--color-white);
  background-color: var(--primary-blue);
  border-color: var(--primary-blue);
  box-shadow: none;
}
.button-width {
  width: 5.625rem;
}

.button-fit-content {
  width: fit-content;
}
</style>
